<template>
  <div :style="pureBaseStyle">
    <div :style="styles.base">
      <template v-if="carouselList.length > 0">
        <div :class="getCss('card_swiper')" ref="cardSwiper">
          <!-- 轮播项的盒子 -->
          <div :class="getCss('card_swiper_box')" ref="cardSwiperBox">
            <!-- 卡片--轮播项 -->
            <div :class="getCss('card')" v-for="(item, index) in carouselList" :key="index" :style="backgroundImage">
              <!-- 卡片左侧 -->
              <div :class="getCss('card_left')">
                <!-- 俱乐部名称 -->
                <h1 :class="getCss('card_left_h1')" :style="titleStyle">{{ item.club_name }}</h1>
                <div :class="getCss('card_left_context')">
                  <!-- 特色1标题 -->
                  <div :class="getCss('card_left_h2')" ref="featureOne">
                    <h2 ref="featureOneTitle" :style="featureOneTitleStyle">{{ item.title }}</h2>
                  </div>
                  <!-- 特色1正文 -->
                  <h3 :class="getCss('card_left_h3')" :style="featureOneContentStyle">{{ item.content }}
                  </h3>
                </div>
                <!-- 特色2标题 -->
                <ul :class="getCss('card_left_ul')">
                  <li :style="featureTwoTitleStyle">{{ item.title_two || `欢迎加入【${item.club_name}】` }}</li>
                </ul>
              </div>
              <!-- 卡片右侧 -->
              <div :class="getCss('card_right')">
                <p :style="platStyle">
                  <!-- 平台名称 -->
                  <span>{{ getPlatformName(item.plat) }}</span>
                </p>
                <img :src="item.club_avatar" alt="" :class="getCss('card_right_img')">
                <button :style="buttonBackgroundImage(item)" @click="joinClub($event, item)">
                </button>
              </div>
            </div>

          </div>
        </div>
        <!-- 轮播指示器 -->
        <ul :class="getCss('card_swiper_indicator')" ref="card_swiper_indicator">
          <li ref="cardSwiperIndicatorLi" v-for="item in indicatorList" :key="item" :style="indicatorStyle">
          </li>
        </ul>
        <!-- 换一批按钮 -->
        <button :class="getCss('card_change_button')" @click="changeBatch" :style="changeBatchStyle">换一批</button>
      </template>
      <!-- 卡片兜底 -->
      <div v-else :style="revealBackgroundImage" :class="getCss('card_reveal_box')"></div>
    </div>
    <!-- 加入俱乐部浮层 -->
    <CTgclubJoinClubPopup
      ref="joinClubPopup"
      :clubId="clubId"
      :problemData="problemData"
      @submitStatus="submitStatus"
      :configurationData="configurationData"
      :communityList="communityList"
      :joinClubList="joinClubList"
    >
    </CTgclubJoinClubPopup>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import CTgclubJoinClubPopup from '@tencent/ceiba-act-tgclub-join-club-popup';
import {
  OPEN_JOIN_CLUB_QUESTION,
  OPEN_JOIN_CLUB_APPLY,
  OPEN_JOIN_CLUB_SUCCESS,
  OPEN_GO_UNION_SQUARE,
  OPEN_JOIN_CHAT,
} from '@tencent/ceiba-act-tgclub-join-club-popup/constant';

// 定义一个过渡滑动效果的函数
const moveTransition = function (obj, distance) {
  const element = obj;
  element.style.transition = 'all .3s';  // 添加过渡效果，0.3s完成图片滚动
  element.style.transform = `translateX(${distance}px)`;
};
// 定义一个没有过渡滑动效果的函数
const moveNoTransition = function (obj, distance) {
  const element = obj;
  element.style.transition = 'none';  // 去掉过渡效果，让card_swiper_box快速跳到目标位置
  element.style.transform = `translateX(${distance}px)`;
};
export default {
  name: 'CTgclubRecommendClubs',
  components: {
    [CTgclubJoinClubPopup.name]: CTgclubJoinClubPopup,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-recommend-clubs-',
      carouselList: [], // 轮播的数据
      indicatorList: [0, 1, 2], // 指示器数据
      indicatorCurrentIndex: 0, // 轮播指示器小圆点
      changeBatchIndex: 0, // 换一批次数记录
      clubId: 0, // 当前加入的俱乐部id
      clubsCommunity: [], // 全部的俱乐部社群
      problemData: {}, // 加入俱乐部问题
      communityList: [], // 已加入俱乐部社群
      joinClubList: [], // 已加入的俱乐部列表
    };
  },
  computed: {
    pureBaseStyle() {
      return {
        left: this.styles.base.left,
        top: this.styles.base.top,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    backgroundImage() {
      return { backgroundImage: `url(${this.configurationData.backgroundImage || ''})` };
    },
    revealBackgroundImage() {
      return { backgroundImage: `url(${this.configurationData.revealBackgroundImage || ''})` };
    },
    buttonBackgroundImage() {
      return (item) => {
        const { isJoin } = this.clubsCommunity.find(clubCommunity => clubCommunity.clubId === item.club_id) || {};
        // 已加入俱乐部，显示进入群聊按钮
        if (isJoin) {
          return { backgroundImage: `url(${this.configurationData.communityBtnBackgroundImage || ''})` };
        }
        // 未加入俱乐部，显示加入按钮
        return { backgroundImage: `url(${this.configurationData.joinBtnBackgroundImage || ''})` };
      };
    },
    titleStyle() {
      return this.styles.titleStyle || {};
    },
    featureOneTitleStyle() {
      return this.styles.featureOneTitleStyle || {};
    },
    featureOneContentStyle() {
      return this.styles.featureOneContentStyle || {};
    },
    featureTwoTitleStyle() {
      return this.styles.featureTwoTitleStyle || {};
    },
    platStyle() {
      return this.styles.platStyle || {};
    },
    changeBatchStyle() {
      return this.styles.changeBatchStyle || {};
    },
    indicatorStyle() {
      return this.styles.indicatorStyle || {};
    },
    defaultColor() {
      return this.configurationData.defaultColor || '#cccccc';
    },
    highlightColor() {
      return this.configurationData.highlightColor || '#f70303';
    },
    scrollbarStyle() {
      return this.styles.scrollbarStyle || { backgroundColor: '#979292' };
    },
    // 是否开启加入群聊模式，已加入俱乐部显示去群聊，未加入俱乐部显示加入俱乐部
    isQueryClubCommunity() {
      return !!this.configurationData.communityFlowID;
    },
  },
  mounted() {
    // 判断编辑环境或非编辑环境
    if (this.$isInEditor) return;

    // 判断是否登录，登录后在执行下面的操作
    this.$onLogined(async () => {
      await this.initialize();
      await this.getClubsCommunity();
      await this.cardSwiper();
      await this.cardWordLoop();
    });
  },
  methods: {
    async initialize() {
      const { gid = this.currentGid, refresh_type: type, player_club_square_plat: plat, context = '' } = this.configurationData;
      const params = {
        gid: parseInt(gid, 10),
        refresh_type: parseInt(type, 10),
        player_club_square_plat: parseInt(plat, 10),
        context,
      };
      const response = await this.$requestInstance.post('https://bgw.xinyue.qq.com/Commander.UpbotCommanderSrv/GetClubListByGid', params);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        this.$alert(msg);
        return;
      }
      const list = data.list || [];
      // 循环获取一组三个不同的列表数据
      const cardList = [];
      for (let randomIndex = 0; randomIndex < 3; randomIndex++) {
        if (list[randomIndex]) {
          cardList.push({
            club_name: list[randomIndex].club.club_name,
            club_avatar: list[randomIndex].club.club_avatar,
            club_id: list[randomIndex].club.club_id,
            gid: list[randomIndex].club.gid,
            plat: list[randomIndex].club.plat,
            title: this.getTypeFiled(list[randomIndex].features[0], list[randomIndex].features[0]?.type, 'title'),
            content: this.getTypeFiled(list[randomIndex].features[0], list[randomIndex].features[0]?.type, 'content'),
            title_two: this.getTypeFiled(list[randomIndex].features[1], list[randomIndex].features[1]?.type, 'title'),
          });
        }
      }
      if (cardList.length > 0) {
        const lastData = cardList[cardList.length - 1];
        if (cardList.length === 1) {
          this.carouselList = [lastData, ...cardList, cardList[0], lastData, lastData];
        } else if (cardList.length === 2) {
          this.carouselList = [lastData, ...cardList, cardList[0], cardList[0]];
        } else {
          this.carouselList = [lastData, ...cardList, cardList[0]];
        }
      } else {
        this.carouselList = [];
      }
    },
    /**
     * 批量查询俱乐部加入状态。未加入则判断审核状态。已加入则返回社群列表
     * @returns {Promise<void>}
     */
    async getClubsCommunity() {
      const allPromise = [];
      const clubIdList = [];
      this.carouselList.forEach((item) => {
        if (!clubIdList.find(clubId => clubId === item.club_id)) {
          clubIdList.push(item.club_id);
          allPromise.push(this.getClubCommunity({ clubId: item.club_id }));
        }
      });
      console.log('【CTgclubRecommendClubs】getClubsCommunity clubIdList = ', clubIdList);
      if (allPromise.length > 0) {
        this.clubsCommunity = await Promise.all(allPromise);
        console.log('【CTgclubRecommendClubs】getClubsCommunity this.clubsCommunity = ', this.clubsCommunity);
      }
    },
    /**
     * 查询俱乐部加入状态。未加入则判断审核状态。已加入则返回社群列表
     * @param clubId
     * @returns {Promise<{}>}
     */
    async getClubCommunity({ clubId }) {
      const { communityFlowID } = this.configurationData;
      if (!communityFlowID) return {};
      const response = await this.flowRequest({
        flowId: communityFlowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ clubId }),
        },
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.$alert(msg);
        return {};
      }
      const { ret: resRet, list = [], join, apply } = data || {};
      if (resRet !== 0) {
        return {};
      }
      return {
        list,
        isJoin: join === 1,
        isApply: apply === 1,
        clubId,
      };
    },
    /**
     * 获取type对应类型字段数据
    */
    getTypeFiled(obj, val, key) {
      const typeFiled = {
        1: 'text',
        2: 'image',
        3: 'video',
        4: 'audio',
      };
      const field = typeFiled[val] || '';

      // 判空处理字段内容均为空则返回空
      return obj && field && obj[field] ? obj[field][key] : '';
    },
    /**
     * 获取plat对应平台名称
    */
    getPlatformName(val) {
      const platformName = {
        0: '未知',
        1: '微信区',
        2: 'QQ区',
        3: '全区服',
      };
      return platformName[val] || '';
    },
    /**
     * 卡片轮播事件
    */
    async cardSwiper() {
      const that = this;
      const { cardSwiper, cardSwiperBox, cardSwiperIndicatorLi } = that.$refs;

      // 获取focus的宽度
      const w = cardSwiper.offsetWidth;
      // 1. 利用定时器
      let index = 0;
      let timer = setInterval(() => {
        index += 1;
        const translatex = -index * w;
        moveTransition(cardSwiperBox, translatex);
      }, 3000);

      // 2. 监听过渡完成事件transitionend

      cardSwiperBox.addEventListener('transitionend', () => {
        if (index > 2) {
          index = 0;
        } else if (index < 0) {
          index = 2;
        }
        const translatex = -index * w;  // 利用新的索引号获取宽度
        moveNoTransition(cardSwiperBox, translatex);

        // 3. 小圆点高亮
        Array.prototype.slice.call(cardSwiperIndicatorLi).forEach((ele) => {
          const element = ele;
          element.style.backgroundColor = that.defaultColor;
        });
        Array.prototype.slice.call(cardSwiperIndicatorLi)[index].style.backgroundColor = that.highlightColor;
        that.indicatorCurrentIndex = index;
      });

      // 4. 手指移动轮播图
      // 触摸元素touchstart 获取手指的初始位置
      let startX = 0; // 定义X轴手指位置
      let startY = 0; // 定义Y轴手指位置
      let moveY = 0; // 定义Y轴移动距离
      let moveX = 0; // 定义X轴移动距离
      let flag = false; // 判断是否滑动了
      cardSwiperBox.addEventListener('touchstart', (e) => {
        e.stopPropagation();
        startX = e.targetTouches[0].pageX;
        startY = e.targetTouches[0].pageY;

        // 停止定时器
        clearInterval(timer);
      });

      // 移动元素touchmove 获取移动距离
      cardSwiperBox.addEventListener('touchmove', (e) => {
        moveX = e.targetTouches[0].pageX - startX;
        moveY = e.targetTouches[0].pageY - startY;

        // 移动盒子：盒子原来的距离 + 移动的距离

        const translatex = -index * w + moveX;
        moveNoTransition(cardSwiperBox, translatex);
        if (Math.abs(moveX) > Math.abs(moveY)) {
          e.preventDefault();  // 阻止默认事件
        }
        flag = true;
      });
      // 手指离开touchend，根据手指移动的距离来判断是否移动到上一张或者下一张
      cardSwiperBox.addEventListener('touchend', () => {
        // 如果滑动了，才进行如下的判断操作
        if (flag) {
          // 判断如果移动距离大于50px那么就移动到下一张或上一张
          if (Math.abs(moveX) > 50) {
            // 如果是右滑就表示滑动到上一张，moveX>0
            if (moveX > 0) {
              index -= 1;
            } else {
              // 如果是左滑就表示滑动到下一张，moveX<0
              index += 1;
            }
          }
          const translatex = -index * w;
          moveTransition(cardSwiperBox, translatex);
        }
        // 手指离开后开启定时器
        clearInterval(timer);
        timer = setInterval(() => {
          index += 1;
          const translatex = -index * w;
          moveTransition(cardSwiperBox, translatex);
        }, 3000);
        flag = false;
      });
    },
    /**
     * 文字走马灯效果
    */
    async cardWordLoop() {
      this.$nextTick(() => {
        const { featureOne, featureOneTitle } = this.$refs;
        const div = Array.prototype.slice.call(featureOne)[0];
        const title = Array.prototype.slice.call(featureOneTitle).splice(1, 3);
        title.forEach((ele) => {
          const element = ele;
          element.style.animation = 'none';
          if (element.offsetWidth > div.offsetWidth) {
            element.style.animation = '10s wordsLoop linear infinite';
          }
        });

        // 特色1正文滚动条样式
        const sty = document.createElement('style');
        sty.innerText = `.csu-tgclub-recommend-clubs-card_left h3::-webkit-scrollbar-thumb{background-color: ${this.scrollbarStyle.backgroundColor};}`;
        document.body.appendChild(sty);
      });
    },
    /**
     * 换一批
    */
    async changeBatch() {
      await this.initialize();
      await this.getClubsCommunity();
      await this.cardWordLoop();
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'another_recommend',
        eventData: {
          status: '1',
        },
      });
    },
    /**
     * 加入俱乐部
    */
    async joinClub(event, item) {
      // 阻止冒泡
      event.stopPropagation();
      // 兼容旧活动
      if (!this.isQueryClubCommunity) {
        window.location.href = `https://xinyue.qq.com/m/flutter_web/#/unionHome?gid=${item.gid}&clubId=${item.club_id}`;
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'join_club',
          eventData: {
            status: '1',
          },
        });
        return;
      }
      const {
        isJoin,
        isApply,
        list = [],
      } = this.clubsCommunity.find(clubCommunity => clubCommunity.clubId === item.club_id) || {};
      this.clubId = item.club_id;
      this.communityList = list;
      // 已加入俱乐部，查看群聊
      if (isJoin) {
        this.joinClubList = await this.queryJoinClubList() || [];
        this.$nextTick(() => {
          this.$refs.joinClubPopup.open({ type: OPEN_JOIN_CHAT });
        });
      }
      // 未加入俱乐部未加入审批，加入俱乐部
      if (!isJoin && !isApply) {
        await this.handleReview({ clubId: item.club_id });
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'join_club',
          eventData: {
            status: '1',
          },
        });
      }
      // 加入俱乐部审批中
      if (!isJoin && isApply) {
        this.toast('审核中');
      }
    },
    /**
     * 加入俱乐部是否需要问题or审核
     * @param clubId
     * @returns {Promise<void>}
     */
    async handleReview({ clubId }) {
      const response = await this.flowRequest({
        flowId: this.configurationData.reviewFlowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({ clubId }),
        },
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const {
        reason,
        question,
        refuse,
        ret: resRet,
        question_type: questionType,
        allow_count: allowCount,
      } = data || {};
      if (resRet !== 0) {
        return;
      }
      // 问题类型=0直接加入，1/2回答问题后才可加入
      if (questionType !== 0) {
        if (allowCount <= 0) {
          this.getPopPrompt(refuse, reason);
          return;
        }
        this.$set(this.problemData, 'question', question);
        this.$set(this.problemData, 'questionType', questionType);
        this.$set(this.problemData, 'allowCount', allowCount);
        this.$nextTick(() => {
          this.$refs.joinClubPopup.open({ type: OPEN_JOIN_CLUB_QUESTION });
        });
      } else {
        await this.handleJoinClub({ questionType, allowCount, refuse, reason, clubId });
      }
    },
    /**
     * 直接加入俱乐部（无需回答问题）
     * @param questionType
     * @param allowCount
     * @param refuse
     * @param reason
     * @param clubId
     * @returns {Promise<void>}
     */
    async handleJoinClub({ questionType, allowCount, refuse, reason, clubId }) {
      if (questionType === 0) {
        if (allowCount <= 0) {
          this.getPopPrompt(refuse, reason);
          return;
        }
        const response = await this.flowRequest({
          flowId: this.configurationData.joinClubFlowID,
          params: {
            role: this.roleInfo,
            data: JSON.stringify({ clubId }),
          },
        });
        const { ret, msg, data } = response;
        if (ret !== 0) {
          return this.$alert({ msg });
        }
        const { ret: resRet } = data || {};
        if (resRet !== 0) {
          return;
        }
        this.clubsCommunity.forEach((clubCommunity) => {
          if (clubCommunity.clubId === clubId) {
            Object.assign(clubCommunity, { isJoin: true });
          }
        });
        console.log('【CTgclubRecommendClubs】handleJoinClub this.clubsCommunity = ', this.clubsCommunity);
        this.$nextTick(() => {
          this.$refs.joinClubPopup.open({ type: OPEN_JOIN_CLUB_SUCCESS });
        });
      }
    },
    /**
     * 问答提交事件触发
     * @param ret
     * @param clubId
     */
    submitStatus({ ret, clubId }) {
      if (ret === 'check') {
        this.clubsCommunity.forEach((clubCommunity) => {
          if (clubCommunity.clubId === clubId) {
            Object.assign(clubCommunity, { isApply: true });
          }
        });
      }
      if (ret === 'success') {
        this.clubsCommunity.forEach((clubCommunity) => {
          if (clubCommunity.clubId === clubId) {
            Object.assign(clubCommunity, { isJoin: true });
          }
        });
      }
      console.log('【CTgclubRecommendClubs】submitStatus this.clubsCommunity = ', this.clubsCommunity);
    },
    /**
     * 弹框提示语
     * @param type
     * @param reason
     */
    getPopPrompt(type, reason) {
      if (type === '1') {
        this.toast(reason);
      } else {
        this.$confirm({
          msg: '当前已加入俱乐部个数超过上限（5个），超过上限后需要到俱乐部主页点击退出，才能加入新的俱乐部',
          confirmText: '查看我的俱乐部',
          cancelText: '关闭',
          confirm() {
            window.location.href = 'https://xinyue.qq.com/m/flutter_web/#/myJoinedClubPage';
          },
        });
      }
    },
    /**
     * 查询已加入的俱乐部列表
     * @returns {Promise<void|*>}
     */
    async queryJoinClubList() {
      const response = await this.flowRequest({
        flowId: this.configurationData.queryJoinFlowID,
        params: {
          role: this.roleInfo,
        },
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, list } = data || {};
      if (resRet !== 0) {
        return;
      }
      const joinClubList = JSON.parse(list || '[]');
      return joinClubList.map((item) => {
        const { club_id: clubId, club_name: clubName } = item;
        return { clubId, clubName };
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
